import { render, staticRenderFns } from "./HistoricalBookings.vue?vue&type=template&id=f624e884"
import script from "./HistoricalBookings.vue?vue&type=script&lang=js"
export * from "./HistoricalBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports